import {EVENT} from '@constants/resources';
import * as MESSAGES from '@constants/messages';
import * as formUtils from '@modules/events/utils/formHelper';
import {applyPresetFieldsForModel, getEventDefaultFields, presetFieldsForModel} from '@modules/events/forms/EventModel';
import {createStEvent, updateStEvent, deleteEvent} from '@graphql/stEvent/mutation';
import Form from '@appComponents/ReduxFormControls';
import {stageEventOptionsQuery} from '@graphql/stEvent/query';
import {renderStageTitle} from '@modules/events/forms/ExistingStageEvent/stageModelHelper';
import {validate} from '@modules/events/forms/ExistingStageEvent/validator';

export default function ExistingStageEventModel(props = {}, isEdit=false) {
    const {optionsVariables = {}} = props;
    const {stageId} = optionsVariables;

    let existingStageEvent = {
        formName: 'ExistingStageEvent',
        entityDataMapKey: 'event',
        id: 'ExistingStageEventModel',
        title: renderStageTitle(stageId),
        label: 'Event',
        entityLabel: 'Event',
        resources: EVENT,
        validate: validate,
        dataMap: {},
        messages: {
            boxName: {
                delete: 'eventsIndex',
                success: 'event',
                error: 'event',
            },
            text: MESSAGES,
            delete: MESSAGES.EVENT_DELETE_STATUS_TEXT_OBJECT,
            create: MESSAGES.EVENT_CREATE_UPDATE_STATUS_TEXT_OBJECT,
            update: MESSAGES.EVENT_CREATE_UPDATE_STATUS_TEXT_OBJECT,
        },
        mutation: {
            updateEntity: updateStEvent,
            createEntity: createStEvent,
            deleteEntity: deleteEvent,
        },
        query: {
            getOptions: stageEventOptionsQuery,
        },
        fields: {
            property_licence: {
                dataMapKey: 'event.property_licence.id',
                optionsKey: 'property_licences',
                props: {
                    component: formUtils.renderPropertyLicenceField,
                    showLink: false,
                    label: 'Property licence',
                    required: true,
                    name: 'property_licence',
                    placeholder: 'Select property licence',
                    type: 'select',
                },
            },
            ...applyPresetFieldsForModel(isEdit),
            stage_category: {
                props: {
                    component: Form.TextPlaceholder,
                    label: 'Stage category',
                    name: 'stage_category',
                    type: 'text',
                },
            },
            stage_type: {
                dataMapKey: 'event.st_event.stage.stage_type.name',
                props: {
                    component: Form.TextPlaceholder,
                    label: 'Stage type',
                    name: 'stage_type',
                    type: 'text',
                },
            },
            stage_name: {
                dataMapKey: 'event.st_event.name',
                props: {
                    component: Form.TextPlaceholder,
                    label: 'Stage name',
                    name: 'stage_name',
                    type: 'text',
                },
            },
            stage_description: {
                dataMapKey: 'event.st_event.description',
                props: {
                    component: Form.TextPlaceholder,
                    label: 'Stage description',
                    name: 'stage_description',
                    type: 'text',
                },
            },
            stadium: {
                dataMapKey: null,
                props: {
                    component: Form.TextPlaceholder,
                    label: 'Venue',
                    name: 'stadium',
                },
            },
            synchronise_times: {
                dataMapKey: 'event.st_event.synchronise_times',
                props: {
                    component: Form.SemanticInput,
                    name: 'synchronise_times',
                    type: 'checkbox',
                    label: 'Synchronise the start time with Sportradar?',
                    defaultValue: true,
                },
            },
            stage_category_id: {
                component: Form.IdField,
                dataMapKey: null,
                props: {
                    hidden: true,
                    label: '',
                    name: 'stage_category_id',
                },
            },
        },
    };

    existingStageEvent.fields = {
        ...existingStageEvent.fields,
        ...getEventDefaultFields(),
        ...presetFieldsForModel(),
    };

    return existingStageEvent;
}
